import { Col, Container, Row } from "react-bootstrap"
import { useParams } from "react-router"
import { useGetInquiryByIdQuery } from "../../../services/bClientApi"

export default function InquiryPage() {
  const { inquiryId = '' } = useParams()

  const {
    data,
    error,
    isLoading
  } = useGetInquiryByIdQuery(inquiryId, { skip: !inquiryId })
  const inquiryData = data || {}


  return (
    <Container>
      <Row>
        <Col>
          <h1>Single Inquiry Page</h1>
          <hr />
          {error && (<>{JSON.stringify(error)}<br /></>)}

          {inquiryId && inquiryData && !isLoading && (
            <div className="inquiryinfo">
              <pre>
                {JSON.stringify(inquiryData, null, 2)}            
              </pre>
            </div>
          )}
        </Col>
      </Row>
    </Container>
  )
}
